import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type State = {
  defaultFilter: string
}

export type Action = {
  actions?: {
    setDefaultFilter: (filter: string) => void
  }
}

export const useCustomerSearchInputStore = create(
  persist<State & Action>(
    (set) => ({
      defaultFilter: 'razao_social_nome',
      actions: {
        setDefaultFilter: (filter) => {
          set({
            defaultFilter: filter,
          })
        },
      },
    }),
    {
      name: 'client-search-input',
      partialize: (state) => ({
        defaultFilter: state.defaultFilter,
      }),
    },
  ),
)
